import { RouteRecordRaw } from 'vue-router';
import { AdminPositionsPage } from '@/pages/admin';

export const routeName = 'AdminCargos';

export const route: RouteRecordRaw = {
  path: 'cargos',
  name: routeName,
  component: AdminPositionsPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Cargos',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};